import React, { Fragment, useEffect, useRef, useState } from "react";
import AppURL from "../../../../widgets/AppURL";
import { fetchDataFromApi } from "../../../../widgets/api";
import { pageTitle } from "../../../../store/softSlice";
import { useDispatch } from "react-redux";
import Container from "../../../../widgets/Container";
import IDCardPrintView from "../../../../components/hr/report/id_card_print/IDCardPrintView";
import { CardPrintBtn } from "../../../../widgets/AppBtn";
import { useReactToPrint } from "react-to-print";
import PrintTeacherIDCard from "../../../../components/hr/report/id_card_print/utils/PrintTeacherIDCard";

const TeacherIDCardPrintCreateListView = ({ PageTitle, setIconsButton }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageTitle({ title: PageTitle }));
    setIconsButton(<CardPrintBtn onClick={handlePrintCard} />);
    document.title = `${PageTitle}`;
  }, []);
  const [selectedRows, setSelectedRows] = useState([]);

  const [onEmployeeList, setOnEmployeeList] = useState([]);
  const url = AppURL.HR_URL + "hr-staff-id-card-list-view/";
  const fetchAcademicsListView = async (urls) => {
    try {
      await fetchDataFromApi(urls).then((res) => {
        setOnEmployeeList(res);
      });
    } catch (error) {
      console.log(error);
    }
  };
  const FetchData = async () => {
    await fetchAcademicsListView(url);
  };
  useEffect(() => {
    FetchData();
  }, []);

  const componentListRef = useRef();

  const RenderListComponent = React.forwardRef((props, ref) => {
    // Filter out undefined or null entries from student_card_list
    const filteredStudentCardList = Array.isArray(onEmployeeList?.data) && onEmployeeList?.data?.filter(student => selectedRows?.includes(student?.member_sn));
    return (
      <Fragment>
        <PrintTeacherIDCard onEmployeeList={onEmployeeList} filteredStudentCardList={filteredStudentCardList} />
      </Fragment>
    );
  });
  const handlePrintCard = useReactToPrint({
    content: () => componentListRef.current, // Reference the component for printing
  });
  return (
    <Container>
      <IDCardPrintView onEmployeeList={onEmployeeList} setSelectedRows={setSelectedRows} selectedRows={selectedRows} />
      <div className="hidden">
        <div ref={componentListRef}>
          <RenderListComponent />
        </div>
      </div>
    </Container>
  );
};

export default TeacherIDCardPrintCreateListView;
